import styled from 'styled-components';

import NumberInput from 'components/NumberInput';

import BaseInput from './BaseInput';

export default styled(NumberInput)`
  ${BaseInput};
`;
